import { MDSTagProps } from '@marqvision/mds-v2';
import { WebsiteContentRouteEnum } from '~/router/@types';
import {
  MarqBrandEnumsWebsiteBrandSortedColumnEnum,
  MarqCommonEnumsScannedStatusEnum,
  MarqCommonEnumsSortedOrderEnum,
} from '~/swagger/data-contracts';
import { reportStatus, SortValue, WebsiteContentColumnEnum, WebsiteContentTabGroupEnum } from './@types';

export const SCANNED_STATUS_DROPDOWN_LIST = [
  {
    label: 'All',
    value: MarqCommonEnumsScannedStatusEnum.All,
  },
  {
    label: 'Recently scanned',
    value: MarqCommonEnumsScannedStatusEnum.RecentlyScanned,
  },
  {
    label: 'Irrelevant',
    value: MarqCommonEnumsScannedStatusEnum.Irrelevant,
  },
];

export const TAB_INFO = {
  [WebsiteContentTabGroupEnum.Scanned]: {
    key: WebsiteContentTabGroupEnum.Scanned,
    label: 'Scanned',
    path: WebsiteContentRouteEnum.Scanned,
  },
  [WebsiteContentTabGroupEnum.Flagged]: {
    key: WebsiteContentTabGroupEnum.Flagged,
    label: 'Flagged',
    path: WebsiteContentRouteEnum.Flagged,
  },
  [WebsiteContentTabGroupEnum.InProgress]: {
    key: WebsiteContentTabGroupEnum.InProgress,
    label: 'In progress',
    children: [
      {
        label: 'Requested',
        path: WebsiteContentRouteEnum.Requested,
      },
      {
        label: 'Reported',
        path: WebsiteContentRouteEnum.Reported,
      },
    ],
  },
  [WebsiteContentTabGroupEnum.CaseClosed]: {
    key: WebsiteContentTabGroupEnum.CaseClosed,
    label: 'Case closed',
    children: [
      {
        label: 'Removed',
        path: WebsiteContentRouteEnum.Removed,
      },
      {
        label: 'Denied',
        path: WebsiteContentRouteEnum.Denied,
      },
      {
        label: 'Dismissed',
        path: WebsiteContentRouteEnum.Dismissed,
      },
    ],
  },
  [WebsiteContentTabGroupEnum.TestPurchase]: {
    key: WebsiteContentTabGroupEnum.TestPurchase,
    label: 'Test Purchase',
    path: WebsiteContentRouteEnum.TestPurchase,
  },
} as const;

export const COLUMN_LIST: Record<WebsiteContentRouteEnum, WebsiteContentColumnEnum[]> = {
  [WebsiteContentRouteEnum.Scanned]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
    WebsiteContentColumnEnum.Actions,
  ],
  [WebsiteContentRouteEnum.Flagged]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
    WebsiteContentColumnEnum.Actions,
  ],
  [WebsiteContentRouteEnum.Requested]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
    WebsiteContentColumnEnum.Actions,
  ],
  [WebsiteContentRouteEnum.Reported]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
    WebsiteContentColumnEnum.Actions,
  ],
  [WebsiteContentRouteEnum.Removed]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
  ],
  [WebsiteContentRouteEnum.Denied]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
  ],
  [WebsiteContentRouteEnum.Dismissed]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.Comment,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
    WebsiteContentColumnEnum.Actions,
  ],
  [WebsiteContentRouteEnum.TestPurchase]: [
    WebsiteContentColumnEnum.Domain,
    WebsiteContentColumnEnum.TestPurchaseId,
    WebsiteContentColumnEnum.TestPurchaseProgress,
    WebsiteContentColumnEnum.TestPurchaseReport,
    WebsiteContentColumnEnum.Screenshot,
    WebsiteContentColumnEnum.IpAddress,
    WebsiteContentColumnEnum.Title,
    WebsiteContentColumnEnum.Country,
    WebsiteContentColumnEnum.Tag,
    WebsiteContentColumnEnum.FirstScanned,
    WebsiteContentColumnEnum.MetaDescription,
    WebsiteContentColumnEnum.Registrant,
    WebsiteContentColumnEnum.Registrar,
    WebsiteContentColumnEnum.HostingProvider,
    WebsiteContentColumnEnum.MxRecords,
    WebsiteContentColumnEnum.SslCertificate,
    WebsiteContentColumnEnum.LogoDetected,
    WebsiteContentColumnEnum.RegistrationDate,
    WebsiteContentColumnEnum.ExpirationDate,
  ],
};

export const STATUS_TAG_DATA: Record<
  reportStatus,
  {
    label: string;
    color: MDSTagProps['color'];
    icon?: true;
  }
> = {
  reviewing: {
    label: 'Requested',
    color: 'bluegray',
  },
  reported: {
    label: 'Reported',
    color: 'bluegray',
  },
  denied: {
    label: 'Denied',
    color: 'bluegray',
  },
  delisted: {
    label: 'Delisted',
    color: 'green',
    icon: true,
  },
  removed: {
    label: 'Removed',
    color: 'green',
    icon: true,
  },
};

export const SORT_LABEL: Record<SortValue, string> = {
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'First Scanned (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'First Scanned (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`]: 'Domain (Z-A)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`]: 'Domain (A-Z)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Requested date (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Requested date (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Added date (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Added date (Oldest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`]:
    'Comments (Newest)',
  [`${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`]:
    'Comments (Oldest)',
};

// 탭 별 정렬 옵션
export const SORT_LIST: Record<WebsiteContentRouteEnum, SortValue[]> = {
  [WebsiteContentRouteEnum.Scanned]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Flagged]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Requested]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Reported]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.CommentDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Removed]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Denied]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.RequestDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.Dismissed]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.ScannedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
  [WebsiteContentRouteEnum.TestPurchase]: [
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.UpdatedDate}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Desc}`,
    `${MarqBrandEnumsWebsiteBrandSortedColumnEnum.DomainName}+${MarqCommonEnumsSortedOrderEnum.Asc}`,
  ],
};
